import { useParams } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import VideoBrowser from "@/components/feature/VideoBrowser";
import NotFound from "@/pages/NotFound";
import { categoryMeta, type VideoType } from "@/mocks/videos";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const VALID: VideoType[] = ["movie", "tv", "short"];

export default function Category() {
  const { type } = useParams<{ type: string }>();
  const valid = VALID.includes(type as VideoType);
  const videoType = (valid ? type : "movie") as VideoType;
  const meta = categoryMeta[videoType];

  useDocumentMeta({
    title: valid ? `${meta.label}-69视频-丰富的视频资源平台` : "69视频-丰富的视频资源平台",
    description: valid
      ? `69视频${meta.label}频道，${meta.intro}`
      : "69视频为用户提供丰富多样的视频资源。",
    keywords: valid ? `${meta.label},69视频,${meta.label}资源,在线视频` : "69视频,视频资源",
    canonicalPath: valid ? `/category/${videoType}` : "/",
  });

  if (!valid) return <NotFound />;

  return (
    <div className="w-full">
      <section className="w-full px-4 md:px-8 pt-8 pb-6 bg-background-100 border-b border-background-200/70">
        <Breadcrumb items={[{ label: "首页", path: "/" }, { label: "分类" }, { label: meta.label }]} />
        <div className="flex items-center gap-4 mt-5">
          <div className="w-14 h-14 md:w-16 md:h-16 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center shrink-0">
            <i className={`${meta.icon} text-2xl md:text-3xl`} aria-hidden="true"></i>
          </div>
          <div>
            <h1 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">{meta.label}</h1>
            <p className="text-sm text-foreground-600 mt-2 max-w-3xl leading-relaxed">{meta.intro}</p>
          </div>
        </div>
      </section>

      <VideoBrowser type={videoType} variant="category" />
    </div>
  );
}